import { useParsedQuery } from '@/hooks/useParsedQuery'
import { GetOutboundSchedulesRes } from '@/services/outboundSchedule/types'
import { useGetOutboundSchedules } from '@/services/outboundSchedule/useOutboundScheduleQueries'
import dayjs from 'dayjs'
import { useCutOffDate } from './useCutOffDate'
import { OutboundSchedulePageQueryParams } from '../types/query'

export type TimeSlot = {
  date: string // YYYY-MM-DD
} & GetOutboundSchedulesRes['timeSlots'][number]

/**
 *  현재 시간 및 지난 컷오프 보기 체크박스에 따라 필터링된 timeSlots 반환
 *  - 출고일정관리의 하루는 23:00 ~ 22:59이기에 오늘, 전날을 조회하여 combine 과정 필요
 */
export const useGetTimeSlots = (): TimeSlot[] => {
  const { parsedQs } = useParsedQuery<OutboundSchedulePageQueryParams>()
  const showPastCutOff = parsedQs.showPastCutOff === 'true' // default false

  const { cutOffDate, prevCutOffDate, shipperCode } = useCutOffDate()

  const { data: schedulesData } = useGetOutboundSchedules({ date: cutOffDate, shipperCode })
  const { data: prevSchedulesData } = useGetOutboundSchedules({ date: prevCutOffDate, shipperCode })

  const { timeSlots } = schedulesData ?? {}
  const { timeSlots: prevTimeSlots } = prevSchedulesData ?? {}

  const filteredTimeSlots = timeSlots?.filter((timeRow) => timeRow.time < '23:00').map((timeRow) => ({ ...timeRow, date: cutOffDate })) ?? []
  const filteredPrevTimeSlots =
    prevTimeSlots?.filter((timeRow) => timeRow.time >= '23:00').map((timeRow) => ({ ...timeRow, date: prevCutOffDate })) ?? []

  const combinedTimeSlots = [...filteredPrevTimeSlots, ...filteredTimeSlots]

  if (showPastCutOff) {
    return combinedTimeSlots ?? []
  }

  return (
    combinedTimeSlots?.filter((timeRow) => {
      const cutOffDateTime = `${timeRow.date} ${timeRow.time}`

      return dayjs().isBefore(dayjs(cutOffDateTime))
    }) ?? []
  )
}
